// ============================================================
// Paginate
// ------------------------------------------------------------
// แถบเลขหน้าใต้ตาราง + ข้อความ "แสดง x รายการ จาก y รายการ"
// เดิม copy อยู่ 14 หน้า
//
// ใช้: <Paginate data={this.state.data} page={this.state.page} onChange={(v) => this.setState({page:v}, this.GetAll)} />
//   data = ก้อนที่ backend ส่งมา ต้องมี { data, count, end_index, page_number }
//   ไม่มีข้อมูล → ไม่แสดงอะไรเลย (เหมือนเดิม)
// ============================================================

import React from "react";
import Pagination from "@mui/material/Pagination";

// className ปรับได้เผื่อหน้าที่ระยะห่างต่างจากมาตรฐาน (คงหน้าตาเดิมของแต่ละหน้าไว้)
export default function Paginate({ data, page, onChange, className = "d-flex justify-content-between row mx-0 w-100 px-3" }) {
  if (!data?.data?.length) return null;
  return (
    <div className={className}>
      <div>
        <label>
          {/* NOTE เดิมแสดงแค่ end_index ("แสดง 1365 รายการ จาก 1365") ดูเหมือนแสดงครบทุกรายการในหน้าเดียว
              ตอนนี้แสดงเป็นช่วงของหน้านั้น (ใช้ start_index ที่ backend ส่งมาอยู่แล้ว) รูปแบบเดียวกับหน้า Billing */}
          แสดง {data.start_index ? `${data.start_index} ถึง ` : ""}{data.end_index} รายการ จาก {data.count} รายการ
        </label>
      </div>
      <Pagination count={data.page_number} page={page} color="primary" showFirstButton showLastButton onChange={(_e, value) => onChange(value)} />
    </div>
  );
}
